// extracted by mini-css-extract-plugin
export default {"NEUTRAL_500":"#424242","product-row":"product-row-a58","product-block":"product-block-c9a","badge":"badge-a47","blue":"blue-d1b","orange":"orange-f83","spacer":"spacer-cea"};